module.exports = __webpack_public_path__ + "static/media/aug-2022.1d2ef7ac.svg";